import { Routes } from '@angular/router';
import { DashboardOcComponent } from './features/dashboard-oc/dashboard-oc.component';
import { DashboardCotComponent } from './features/dashboard-cot/dashboard-cot.component';
import { TablaPaginadaComponent } from './features/tabla-paginada/tabla-paginada.component';

export const routes: Routes = [
  { path: 'dashboard-oc', component: DashboardOcComponent },
  { path: 'dashboard-cot', component: DashboardCotComponent },
  { path: 'tabla-paginada', component: TablaPaginadaComponent },
  { path: '', redirectTo: '/dashboard-cot', pathMatch: 'full' },
];
